import angular from 'angular';

import { PillComponent } from './pill.component';

angular.module('core.components.pill', []).component('easyshipPill', PillComponent);
